module.exports = __webpack_public_path__ + "img/dd-blue.6d2369b1.svg";